/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_SEND_REJECT, REJECTION_RESPONSE_RECEIVED } = constants.SendRejectionConstant;


export default {
    REQUEST_SEND_REJECT,
    REJECTION_RESPONSE_RECEIVED,

  requestSendReject: payload => ({
    type: REQUEST_SEND_REJECT,
    payload
  }),
  sendRejectReceived: () => ({
    type: REJECTION_RESPONSE_RECEIVED
  }),
};
